const actions = {
  OTP_REQUEST: "OTP_REQUEST",
  OTP_SUCCESS: "OTP_SUCCESS",
  OTP_ERROR: "OTP_ERROR",

  RESEND_OTP_REQUEST: "RESEND_OTP_REQUEST",
  RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
  RESEND_OTP_ERROR: "RESEND_OTP_ERROR",

  REFRESH_TOKEN_REQUEST: "REFRESH_TOKEN_REQUEST",
  REFRESH_TOKEN_SUCCESS: "REFRESH_TOKEN_SUCCESS",
  REFRESH_TOKEN_ERROR: "REFRESH_TOKEN_ERROR",

  RESET_ACTIONTYPE: "RESET_ACTIONTYPE",

  otp: (url, body) => ({
    type: actions.OTP_REQUEST,
    payload: { url, body },
  }),

  refreshAccessToken: (url, body) => ({
    type: actions.REFRESH_TOKEN_REQUEST,
    payload: { url, body },
  }),

  resetActionType: () => ({
    type: actions.RESET_ACTIONTYPE,
  }),
};

export default actions;
